import { render, staticRenderFns } from "./ClientBranchSelect.vue?vue&type=template&id=3520a699&lang=pug"
import script from "./ClientBranchSelect.vue?vue&type=script&lang=js"
export * from "./ClientBranchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports